/**
 * US IANA time zone identifiers (tzdata), with short labels for the console UI.
 * Sorted by label for display.
 */
export const US_IANA_TIMEZONES: ReadonlyArray<{ id: string; label: string }> = [
  { id: "America/Adak", label: "Alaska — Adak (Aleutian)" },
  { id: "America/Anchorage", label: "Alaska — Anchorage" },
  { id: "America/Juneau", label: "Alaska — Juneau" },
  { id: "America/Metlakatla", label: "Alaska — Metlakatla" },
  { id: "America/Nome", label: "Alaska — Nome" },
  { id: "America/Sitka", label: "Alaska — Sitka" },
  { id: "America/Yakutat", label: "Alaska — Yakutat" },
  { id: "America/Phoenix", label: "Arizona — Phoenix" },
  { id: "America/Boise", label: "Mountain — Boise" },
  { id: "America/Denver", label: "Mountain — Denver" },
  { id: "America/Chicago", label: "Central — Chicago" },
  { id: "America/Indiana/Indianapolis", label: "Eastern — Indiana (Indianapolis)" },
  { id: "America/Indiana/Knox", label: "Central — Indiana (Knox)" },
  { id: "America/Indiana/Marengo", label: "Eastern — Indiana (Marengo)" },
  { id: "America/Indiana/Petersburg", label: "Eastern — Indiana (Petersburg)" },
  { id: "America/Indiana/Tell_City", label: "Central — Indiana (Tell City)" },
  { id: "America/Indiana/Vevay", label: "Eastern — Indiana (Vevay)" },
  { id: "America/Indiana/Vincennes", label: "Eastern — Indiana (Vincennes)" },
  { id: "America/Indiana/Winamac", label: "Eastern — Indiana (Winamac)" },
  { id: "America/Kentucky/Louisville", label: "Eastern — Kentucky (Louisville)" },
  { id: "America/Kentucky/Monticello", label: "Eastern — Kentucky (Monticello)" },
  { id: "America/Detroit", label: "Eastern — Detroit" },
  { id: "America/New_York", label: "Eastern — New York" },
  { id: "America/Menominee", label: "Central — Menominee (MI / WI)" },
  { id: "America/North_Dakota/Beulah", label: "Central — North Dakota (Beulah)" },
  { id: "America/North_Dakota/Center", label: "Central — North Dakota (Center)" },
  { id: "America/North_Dakota/New_Salem", label: "Central — North Dakota (New Salem)" },
  { id: "America/Los_Angeles", label: "Pacific — Los Angeles" },
  { id: "Pacific/Honolulu", label: "Hawaii — Honolulu" },
  { id: "Pacific/Pago_Pago", label: "American Samoa — Pago Pago" },
  { id: "Pacific/Guam", label: "Guam" },
  { id: "Pacific/Saipan", label: "Northern Mariana Islands — Saipan" },
  { id: "America/Puerto_Rico", label: "Puerto Rico" },
  { id: "America/St_Thomas", label: "US Virgin Islands — St Thomas" }
].sort((a, b) => a.label.localeCompare(b.label));

const US_IDS = new Set(US_IANA_TIMEZONES.map((z) => z.id));

export function isUsIanaTimeZoneId(id: string): boolean {
  return US_IDS.has(id);
}

/** If `current` is not a US zone, prepend it so the select stays controlled and valid. */
export function usTimeZoneSelectRows(current: string): Array<{ id: string; label: string }> {
  const t = current.trim();
  if (t !== "" && !isUsIanaTimeZoneId(t)) {
    return [{ id: t, label: `${t} (current)` }, ...US_IANA_TIMEZONES];
  }
  return [...US_IANA_TIMEZONES];
}
